import {SiteEntity} from "../../commons/models/siteEntity.model";
import {PlanningServerEnum} from "../enums/planning-server.enum";

export enum ConsiderVehicleLocation {
  ConsiderButDoNotIncludeInRoute = "ConsiderButDoNotIncludeInRoute",
  IncludeInRoute = "IncludeInRoute",
  Ignore = "Ignore"
}

// SRV: ConstraintConfiguration
export interface ConstraintConfigurationModel {
  enableConfiguration: boolean;
  weight: number;
  // SRV: MaxRouteDurationConstraintConfiguration
  // SRV: MaxVehicleGroupRouteDurationConstraintConfiguration
  lateUnitsSeconds?: number;
  // SRV: MinimizeBundleVisitConstraintConfiguration
  // SRV: MinimizeLocationVisitConstraintConfiguration
  removeSplitUnassigned?: boolean;
  penaltyPerSplitUnassignedFactor?: number;
  disableTimeWindowCheck: boolean;
  disableCapacityCheck: boolean;
  disableBundlePresenceCheck: boolean;
  noBundleFitPenaltyMultiplier: number;
  // SRV: SoftTimeWindowConstraintConfiguration
  minutesIntervalPoint?: number;
  // SRV: StopToStopDistanceConstraintConfiguration
  distanceLimit?: number;
  highDistanceLimit?: number;
  highWeight?: number;
  hardDistanceLimit?: number;
}

export interface ConstraintConfigurationsModel {
  branchRouteConstraint: ConstraintConfigurationModel;
  locationVehiclePriorityUserdataConstraint: ConstraintConfigurationModel;
  vehicleRoleSoftActivityConstraint: ConstraintConfigurationModel;
  minimizeLocationVisitsConstraint: ConstraintConfigurationModel;
  maxRouteDurationConstraint: ConstraintConfigurationModel;
  maxVehicleGroupRouteDurationConstraint: ConstraintConfigurationModel;
  softTimeWindowConstraint: ConstraintConfigurationModel;
  minimizeBundleVisitsConstraint: ConstraintConfigurationModel;

  // not used in the UI for now
  stopToStopDistanceConstraint: ConstraintConfigurationModel;
  locationClusterSoftConstraint: ConstraintConfigurationModel;

  // soft but in the hard section of the UI
  vehicleConsiderButNotIncludeInRouteSoftActivityConstraint: ConstraintConfigurationModel;
}

export interface VisitScheduleOptimizationSettings extends SiteEntity {
  // hard constraints
  considerTimeWindow: boolean;
  skillsRequired: boolean;
  considerMaxHoursPer7Days: boolean;
  considerDailyMaxHours: boolean;
  respectAssignedBranchesHard: boolean;
  considerDedicatedAgents: boolean;
  considerRestrictedAgentsFromAccounts: boolean;
  considerAccountStrategyPriority: boolean;

  // soft but in the hard section of the UI
  considerVehicleLocation: ConsiderVehicleLocation;

  considerWeeklyHoursGoal: boolean;
  considerDailyHoursGoal: boolean;
  considerPreferredAgents: boolean;
  minimizeAccountVisits: boolean;
  respectAssignedBranchesSoft: boolean;
  rolesPriority: boolean;
  serviceTimeSettings: any;
  locationSettings: any;
  optimizeDispatchedRoutes: boolean;
  bundling: boolean;

  constraintConfigurations?: ConstraintConfigurationsModel;

  planningServer?: PlanningServerEnum;
}
